import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from 'reflexbox';
import styled from 'styled-components';
import { useField } from 'formik';

import * as graphql from 'generated/graphql';
import { SubSectionTitle } from 'packages/kakapo-ui-kit/components/common/Headings';
import QuillField from 'packages/kakapo-ui-kit/components/editors/QuillField';

import { CompetencyLevelsInput } from './CompetencyInput';

const Label = styled(SubSectionTitle)`
	font-size: 14px;
`;

export default function ReviewGoalsInput(props: {
	submission: graphql.EvaluationSubmission;
	competencyLevelSet: graphql.CompetencyLevelSet;
	name: string;
	metadata: { goal: graphql.EvaluationSubmissionGoal };
	initialValue?: graphql.EvaluationSubmissionItemReviewGoal[];
}) {
	const { t } = useTranslation();

	const { goal } = props.metadata;

	const [{ value }, , { setValue }] = useField<{
		type: graphql.EvaluationSectionItemType.ReviewGoals;
		reviewGoals: graphql.EvaluationSubmissionItemReviewGoalInput[];
	}>(props.name);

	useEffect(() => {
		if (!value && props.initialValue) {
			setValue({
				type: graphql.EvaluationSectionItemType.ReviewGoals,
				reviewGoals: props.initialValue!,
			});
		}
	}, [!!value]);

	const reviewGoals = value?.reviewGoals ?? props.initialValue ?? [];

	const index = reviewGoals.findIndex(({ goalID }) => goalID === goal.goal.id);
	const enabled = index >= 0;

	return (
		<>
			{enabled && (
				<>
					<Box>
						<Label>{t('evaluation.submission.reviewGoals.scoreLabel')}</Label>
						<Box mt={2}>
							<CompetencyLevelsInput
								competency={
									{
										levels: props.competencyLevelSet.levels.map((level) => ({
											enabled: true,
											level,
										})),
									} as any
								}
								name={`${props.name}.reviewGoals.${index}`}
								party={graphql.EvaluationSubmissionParty.Employee}
							/>
						</Box>
					</Box>
					<Box mt={3}>
						<Label>{t('evaluation.submission.reviewGoals.explanationLabel')}</Label>
						<Box mt={2}>
							<QuillField
								name={`${props.name}.reviewGoals.${index}.text`}
								wide
								boxedStyling
								theme="snow"
							/>
						</Box>
					</Box>
				</>
			)}
		</>
	);
}
